import { useForm } from "react-hook-form";
import { TranferirAtendimentoController } from "../../../../Controllers/AtendimentoCliente/Atendimento/AtendimentoControllers";
import { useHistoricoContext } from "../../../../Context/Historico";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import CustomSelect from "../../Forms/LabelSelect";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useState } from "react";
import { groupBy } from "../../../../Tools/ProcessingTools";
import OrSpinner from "../../../Utils/OrSpinner";
import { ListarUsuariosTransferenciaController } from "../../../../Controllers/Geral/GestaoUsuarios/UsuariosController";
import { TModoGestaoAtendimento } from "../../../../Interfaces/AtendimentoCliente/GestaoDeAtendimento/GestaoDeAtendimentoInterfaces";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import UnForm from "../../../Form";
import { faExchangeAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IComponentModal } from "../../../Modais/IModalComponent";
import ModalComponent from "../../../Modais";

interface ITransferirAtendimentoProps {
    setShow: (show: boolean) => void;
    update: () => void;
    ID_CASOS?: Array<number>;
    filter?: any;
    SEG_ATENDIMENTOS?: TModoGestaoAtendimento;

    controller: () => Promise<any>;

    ID_TIPO_CASO: number;
}

export default function TransferirTodosAtendimento(
    props: ITransferirAtendimentoProps
) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();
    return (
        <>
            <ul className="sticky-toolbar nav flex-column pl-2 pr-2 pt-3 pb-3 mt-40">
                <li
                    className="nav-item"
                    data-toggle="tooltip"
                    title="Transferir Todos Atendimentos"
                    data-placement="left"
                    data-original-title="Transferir Atendimentos"
                >
                    <button
                        className="btn btn-sm btn-icon btn-bg-light btn-icon-info btn-hover-success"
                        onClick={() => {
                            setModal({
                                Component: () => (
                                    <TransferirTodosAtendimentoComponent
                                        {...props}
                                    />
                                ),
                                IconHeader: faExchangeAlt,
                                headerComponent:
                                    "Transferir Todos Atendimentos",
                            });
                            setShow(true);
                        }}
                    >
                        <FontAwesomeIcon icon={faExchangeAlt} />
                    </button>
                </li>
            </ul>

            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}

function TransferirTodosAtendimentoComponent(
    props: ITransferirAtendimentoProps
) {
    const { reset } = useForm<ITransferirAtendimentoProps>();

    const { controller } = props;

    const { ReloadHistorico } = useHistoricoContext();

    const [idUsuario, setIdUsuario] = useState(0);

    const { value: listarAtendimentos, loading: listarAtendimentosLoading } =
        useAsyncEffect(() => controller(), []);

    const { value: lstUsuarios, loading: lstUsuariosLoading } =
        useAsyncEffect(async () => {
            return ListarUsuariosTransferenciaController({
                DS_STATUS_USUARIO: "Ativos",
                FL_ATENDIMENTO_ABERTO: true,
                ID_TIPO_CASO: props.ID_TIPO_CASO,
            }).then((res) => {
                return res.map((ua) => ({
                    ...ua,
                    ATENDIMENTOS: Array.from(
                        groupBy(ua.ATENDIMENTOS, (a) =>
                            a.ID_TIPO_CASO?.toString()
                        ).values()
                    ).map((as) => ({
                        ...as[0],
                        NR_ATENDIMENTOS_ABERTOS: as.reduce(
                            (sum, a) => sum + (a.NR_ATENDIMENTOS_ABERTOS ?? 0),
                            0
                        ),
                    })),
                }));
            });
        }, []);

    const {
        execute: transferirTodosAtendimentos,
        loading: transferirTodosAtendimentosLoading,
    } = useAsyncCallback(TranferirAtendimentoController);

    function handleTransferirFormSubmit(formData: {
        ID_USUARIO_ACOMPANHAMENTO: number;
    }) {
        if (listarAtendimentos)
            transferirTodosAtendimentos({
                ...formData,
                ID_USUARIO_TRANSFERIR: idUsuario ?? 0,
                ID_CASO: 0,
                ID_CASOS: listarAtendimentos?.map((caso: any) => caso.ID_CASO),
            }).then(() => {
                props.setShow(false);
                props.update();
                reset();
                if (ReloadHistorico) ReloadHistorico();
            });
    }

    return (
        <OrSpinner
            loading={listarAtendimentosLoading || lstUsuariosLoading}
            spinner="capys"
        >
            {lstUsuarios && (
                <UnForm handleSubmit={handleTransferirFormSubmit}>
                    <div className="form-group">
                        <label htmlFor="ID_USUARIO_TRANSFERIR">
                            Transferir para usuário:
                        </label>
                        <CustomSelect
                            value={idUsuario}
                            onChange={setIdUsuario}
                            options={lstUsuarios}
                            getKeyValue={(u) => u.ID_USUARIO ?? 0}
                            optionRender={(u) => {
                                const atendimentos = u.ATENDIMENTOS.reduce(
                                    (sum, ua) =>
                                        sum + (ua.NR_ATENDIMENTOS_ABERTOS ?? 0),
                                    0
                                );
                                return (
                                    <div className="w-100 d-flex justify-content-between align-items-center">
                                        <span>{u.DS_NOME}</span>
                                        <OverlayTrigger
                                            overlay={
                                                <Tooltip
                                                    className="z-index-1500"
                                                    id="tooltip"
                                                >
                                                    {
                                                        u.ATENDIMENTOS[0]
                                                            ?.DS_TIPO_CASO
                                                    }{" "}
                                                    - {atendimentos} <br />
                                                </Tooltip>
                                            }
                                        >
                                            <span className="label label-rounded label-success">
                                                {atendimentos}
                                            </span>
                                        </OverlayTrigger>
                                    </div>
                                );
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="ID_USUARIO_ACOMPANHAMENTO">
                            Acompanhamento do atendimento:
                        </label>
                        <UnForm.Select
                            className="form-control"
                            name="ID_USUARIO_ACOMPANHAMENTO"
                            registerOptions={{ valueAsNumber: true }}
                        >
                            <option></option>
                            {lstUsuarios.map((usuario) => (
                                <option
                                    value={usuario.ID_USUARIO}
                                    key={usuario.ID_USUARIO}
                                >
                                    {usuario.DS_NOME}
                                </option>
                            ))}
                        </UnForm.Select>
                    </div>

                    <UnForm.SubmitButton
                        className="btn btn-success col-12"
                        type="submit"
                        color="success"
                        icon={faExchangeAlt}
                        wrapperClassName="w-100"
                        loading={transferirTodosAtendimentosLoading}
                        disabled={transferirTodosAtendimentosLoading}
                        loadingSize={"sm"}
                    >
                        Transferir Todos
                    </UnForm.SubmitButton>
                </UnForm>
            )}
        </OrSpinner>
    );
}
